"use client";
import styled from "styled-components";
import {  Box, Grid, Link } from '@mui/material';
import { useEffect, useState, useRef, useCallback } from "react";
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext"; 
import { useMyContext } from '@/app/utils/MyContext';
import { textSize, text_size } from "@/app/utils/MixinSize";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Disclaimer from "@/app/ui/Disclaimer";
import { openSingleTab } from '@/app/utils/Common';
import { generateAdobeDataRaceNo, generateAdobeDataHorseName, adobeData, useViewTracker, openInNewTab} from '@/app/utils/Common';
import _ from 'lodash'; 
import { formattedDate } from "@/app/utils/DayJS"; 
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Stack from '@mui/material/Stack';
import Slide from '@mui/material/Slide';

const ExpertColumnPC = (props:any) => {
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const {betTypeList, commentary, horseList, trackAnalysisExperts, expertName, expertNameEn, menuTab, pmPoolsData} = props;

    const [showDisclaimer, setshowDisclaimer] = useState(false); 
    const OneBSwitch = window.globalConfig?.OneBSwitch;
 
    const betShareRef = useRef<any>(null);
    useEffect(() => {
        const loadSdk = async () => {
          const dynamicImport = new Function(
            "url",
            "return import(url)"
          ) as (url: string) => Promise<any>;
    
          const sdk = await dynamicImport(window.globalConfig.BETSHARE.SDK);
          sdk.init({betShareBaseUrl: window.globalConfig.BETSHARE.DOMAIN, eWinBaseUrl: window?.globalConfig.DATA_SOURCES?.JCBW_DOMAIN});
          betShareRef.current = sdk.betShare;

          console.log("sdk", sdk.betShare)
          //setLoaded(true);
        };
        if(window.globalConfig?.TwoASwitch){ 
            loadSdk().catch(console.error);
        } 
      }, []);

    useEffect(() => {
        document.addEventListener('click', handleOutSideclick);
        return () => {
            document.removeEventListener('click', handleOutSideclick);
        }
    }, [showDisclaimer]);

    const onClickDisclaimer = () => { 
        setshowDisclaimer(true);
        handleWA("Disclaimer")
    }

    const handleOutSideclick = useCallback((event: any) => {
        if(!showDisclaimer) return
       
        const targetDiv = document.querySelector('.hidden-disclaimer');
        const rect = targetDiv?.getBoundingClientRect() || {} as any;
        const isInside =
            event?.clientX >= rect?.left &&
            event?.clientX <= rect?.right &&
            event?.clientY >= rect?.top &&
            event?.clientY <= rect?.bottom;
        if (!isInside) {
            setshowDisclaimer(false)
        }
    }, [showDisclaimer]) 

    const handleWA = ( type: string) => { 
        const pagename = menuTab === "raceCard" ? "Racecard-Expert" : "ExpertColumn";
        const curRace = myContextState.selectedMeeting?.RaceMeetingProfile?.races?.find((r: any) => r.no == myContextState?.selectedRaceNo.valueOf());
         
        adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
            pageId: "racing/simulcast",
            eventId: `racing/simulcast_Click_${pagename}_${type}`,
            country: myContextState.selectedMeeting?.countryNameEn || '',
            author: expertNameEn, 
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        });  
    }

    return <Box sx={{display: { xs: 'none', lg: 'table'}}} style={{width: "100%", position: 'relative'}} id="expertcolumnPC">
            <div style={{ display: "flex"}}>
            <div style={{ flexBasis: betTypeList?.length == 3 ? "33.33%":"50%",paddingLeft:12, paddingBottom: 20}}>
                <BasicContent 
                    betTypeList={betTypeList}
                    commentary={commentary}
                    horseList={horseList}
                    expertName={expertName}
                    expertNameEn={expertNameEn}
                    menuTab={menuTab}
                    trackAnalysisExperts={trackAnalysisExperts}/>
            </div>
            <div style={{ flexBasis: betTypeList?.length == 3 ? "66.66%":"50%"}}>
                <BetWrapper>
                    <AddtoBetslip betShare={betShareRef} pmPoolsData={pmPoolsData} betTypeList={betTypeList} menuTab={menuTab} trackAnalysisExperts={trackAnalysisExperts} expertNameEn={expertNameEn}/>
                </BetWrapper>
                </div>
            </div>
            {
                OneBSwitch &&  
                <div className='disclaimer' >
                    <div>
                        {t("expert_column_hardcode_msg")}
                        <span style={{position: "relative"}} onClick={(e:any) => {
                            e.preventDefault();
                            onClickDisclaimer()
                        }}> 
                        <img src={`${myContextState.assetPrefix}/commonImg/expert_icon.svg`} />
                        {t("expert_column_disclaimer")}
                        <TriangleUpDisclaimer $showDisclaimer={showDisclaimer}/>
                        <HiddenDisclaimer className="hidden-disclaimer" $showDisclaimer={showDisclaimer} onClick={(e) => e.stopPropagation()}>
                            <Disclaimer hideTitle={true} fontSize={13} /> 
                        </HiddenDisclaimer>
                        </span>
                    </div>  
                </div> 
            }
        </Box>
}

const BasicContent = (props: any) => { 
    const {commentary, expertName, expertNameEn, horseList, trackAnalysisExperts, menuTab, betTypeList} =props;
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const [showMore, setshowMore] = useState(false);
    const [ifshowMore, setifshowMore] = useState(false);
    const [show4row, setshow4row] = useState(false);
    const [showText, setshowText] = useState(false);
    const [showCaleNoRow, setshowCaleNoRow] = useState(0);
    const defalutMaxH = useRef(0); 
    const OneBSwitch = window.globalConfig?.OneBSwitch;
    const checkifShowMore = () => {

    } 
    const trakWA = () => {
        handleWA("ExpertPhoto")
    }
    const containsRef = useViewTracker(trakWA, 5000) as React.RefObject<HTMLDivElement>;
   
    
    useEffect(() => {
        if (menuTab == "raceCard") {
             // none commentary
            if (!commentary) {
                setifshowMore(false);
                return 
            }
            // none betTypeList
            if (!betTypeList?.length && commentary) {
                setifshowMore(false);
                // setifshowMore(true);
                // setshow4row(true);
                return
            }
            const left_selections_h = (document.querySelector("#exCol_left_selections") as any)?.clientHeight || 0;
            const right_dom = document.querySelector(".betWrapper1") as any ;
            const right_H = right_dom?.clientHeight;
            const _comentaryDom = document.querySelector("#commentary_content") as any;
            const left_H = 70 + left_selections_h + _comentaryDom?.scrollHeight;

            const offset_h = 0;
            const left_less = left_H < right_H - offset_h;

            console.log("exCol_left------", left_H )
            console.log("betWrapper1------", right_H, left_selections_h)
           
            // have selection , have commentary
            if (betTypeList?.length && commentary) {
                if (left_less) {
                    setifshowMore(false);
                    setshow4row(false);
                    return
                } else {
                    const comMax_H = right_H - 70 - left_selections_h - 70
                    defalutMaxH.current = comMax_H;

                    const caleNoRow = Math.trunc(comMax_H/22);
                    console.log("caleNoRow--- ", comMax_H, caleNoRow, _comentaryDom?.scrollHeight, _comentaryDom?.clientHeight)
                   
                    if (caleNoRow < 4) {
                        setshow4row(true);
                    }else {
                        setshowCaleNoRow(caleNoRow);
                    }
                   
                    setifshowMore(true);
                }
                return 
            }
        }
    }, [commentary, horseList, document.querySelector("#DisclaimerPCRoot")])
    useEffect(() => {
        const _comentaryDom = document.querySelector("#commentary_content") as any;
        if (_comentaryDom?.scrollHeight > 0 && 
            _comentaryDom?.clientHeight > 0 && 
            Math.abs(_comentaryDom?.scrollHeight - _comentaryDom?.clientHeight) <= 2) {
            setifshowMore(false);
            setshow4row(false);
            return
        }
    }, [ifshowMore])
    const handleOutSideclick = useCallback((event: any) => {
        if(!showText) return
       
        const targetDiv = document.querySelector('.hidden-text');
        const rect = targetDiv?.getBoundingClientRect() || {} as any;
        const isInside =
            event?.clientX >= rect?.left &&
            event?.clientX <= rect?.right &&
            event?.clientY >= rect?.top &&
            event?.clientY <= rect?.bottom;
        if (!isInside) {
            setshowText(false)
        }
    }, [showText])
    
    useEffect(() => {
        document.addEventListener('click', handleOutSideclick);
        return () => {
            document.removeEventListener('click', handleOutSideclick);
        }
    }, [trackAnalysisExperts?.expertIntroduction?.value, showText]);
  
    const handleWA = ( type: string, horse?: string, isNeedHorse?: boolean, link?: string, e?:any) => {
        if(link && e) e.preventDefault();
        const pagename = menuTab === "raceCard" ? "Racecard-Expert" : "ExpertColumn";
         
        adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
            pageId: "racing/simulcast",
            eventId: type == "ExpertPhoto" ? `racing/simulcast_Display_Racecard-Expert` : `racing/simulcast_Click_${pagename}_${type}`,
            country: myContextState.selectedMeeting?.countryNameEn || '',
            author: expertNameEn,
            horse: !isNeedHorse ? "" : generateAdobeDataHorseName(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, horse),
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        });

        if(link){ 
            const target = e.currentTarget.getAttribute("target") || "_self";
            const path = `${link}`;
            window.open(path, target) 
        }   
    }
  
    return commentary ?
        <>
        <div id={"exCol_left"}>
            <ExpertColumnHeader ref={menuTab == "raceCard" ? containsRef : null}>
                <ExpertColumnHeaderImg 
                src={trackAnalysisExperts?.expertPicture?.src}
                alt={trackAnalysisExperts?.expertPicture?.alt} />
                 {expertName !== '' ? 
                 <div style={{
                    alignItems: "center",
                    "display": "flex"
                 }}>
                   <InnerSpan >{trackAnalysisExperts?.expertName?.value}</InnerSpan> 
                </div>
                : null }
                <TipsContainer>
                    <div style={{ position: "relative", lineHeight: "10px"}}>
                        <img src={`${myContextState.assetPrefix}/commonImg/expert_icon.svg`} className="HoverIcon"onClick={() => {
                            if(showText) return
                            setshowText(true);
                            handleWA("Info");
                        }}/>
                        <TriangleUp $showText={showText}/>
                    </div>
                </TipsContainer>

                <Hiddentext className="hidden-text" $showText={showText} dangerouslySetInnerHTML={{ __html: trackAnalysisExperts?.expertIntroduction?.value }}>
                      
                </Hiddentext>
            </ExpertColumnHeader> 
            {
                horseList?.length > 0 && <><SelectionsRoot id={"exCol_left_selections"}>
                <SelectionsTitle >
                    {t("expert_column_selection_title")}
                </SelectionsTitle>
                <div style={{
                    flexWrap: "wrap",
                    flexDirection: "row",
                    display: "flex",
                    padding:" 12px 0",
                }}>{horseList?.map((item: any, idx: number) => <HorseListRow key={idx}>
                        <img src={`${myContextState.assetPrefix}/commonImg/horse_selection.svg`} />
                        {
                            item.link ? <Link onClick={(e) => {handleWA("HorseProfile", item.horseNameEn, true, item.link, e); }} href={item.link || 'javascript:;'} target={item.link && "_blank"} sx={{ cursor: item.link ? "pointer" : "default" }} >
                            {`${item.horseNumber}. ${item.horseName}`}
                            </Link> : <span>{`${item.horseNumber}. ${item.horseName}`}</span>
                        }
                    </HorseListRow>) || <></>}
                    </div></SelectionsRoot>
                    </>
            }

            <RichTextCommentary 
                $ifshowMore={ifshowMore}
                $showCaleNoRow={showCaleNoRow}
                $show4row={show4row}
                $showMore={showMore}
                style={{position:"relative"}} id={"commentary_content"}>
                <div dangerouslySetInnerHTML={{ __html: commentary }} />
                {
                    !OneBSwitch &&
                    <div id="DisclaimerPCRoot">
                        <Disclaimer />
                    </div>
                }
                
            </RichTextCommentary>
            
        </div>       
        {ifshowMore && menuTab == "raceCard"? <DisplayMoreLess onClick={() => {
            setshowMore(!showMore)
            handleWA(!showMore ? "More": "Less")
            // if(showMore) {
            //     const dom = document.getElementById("expertcolumn2");
            //     dom?.scrollIntoView();
            // }
            }}> 
            {
                showMore? <>
                {t("show_less")}
                <KeyboardArrowUpIcon/>
                </> : <>
                {t("show_more")}<KeyboardArrowDownIcon/>
                </> 
                } 
            </DisplayMoreLess> : null }
        </>
        : null
}
const AddtoBetslip = (props: any) => { 
    const {betTypeList, pmPoolsData} = props;
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const { state: lang } = useLanguage();
    const { t } = lang;
    const openWin = useRef(null);
    const TwoASwitch = window.globalConfig?.TwoASwitch;
    const [showAddSlipAlert, setShowAddSlipAlert] = useState<boolean>(false);
    const [alertPosition, setAlertPosition] = useState(0);
    const [alerts, setAlerts] = useState<any>([]); 
     
    const getBetSelection = (name: string, isName?: boolean) => {
        const match = name.match(/^(.*?)\s*[（(][^\d]*(\d+)[^）)]*[)）]/);
        if(isName){
            //const match = name.match(/^(.*?)\s*\(/);
            return match ? match[1] : "";
        }else {
            //const match = name.match(/\((\d+)\s/);
            return match ? match[2] : "";
        }
    }
  
    const handleWA = async(type: string, bettypeNo?: string, buttonName?:string, link?: string, e?:any, betList?: any) => {
        if(link && e) e.preventDefault();
        const pagename = props?.menuTab === "raceCard" ? "Racecard-Expert" : "ExpertColumn";
         
        adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
            pageId: "racing/simulcast",
            eventId: `racing/simulcast_Click_${pagename}_${type}`,
            country: myContextState.selectedMeeting?.countryNameEn || '',
            author: props?.expertNameEn,
            bettype: buttonName || "",
            buttonName: buttonName ? `racing/simulcast_Click_${ bettypeNo }` : "", 
            //horse: !isNeedHorse ? "" : generateAdobeDataHorseName(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, horse),
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        });
         
        if(type == "AddSlip" && TwoASwitch){
            if(link) { 
                window.open(link);
            } else {    
                const legs = betList?.map((x: any) => {
                    return({
                        raceNo: x?.raceNumber,
                        selections: buttonName == "D-T" ? x?.selections?.map((s: any) => s.horseNum?.toString()) : x?.combination?.map((s: any) => s.horseNum?.toString()),
                        bankers: buttonName == "D-T" ? x?.banker?.map((s: any) => s.horseNum?.toString()) : []
                    })
                })
                console.log("sdk AddSlip", props?.betShare, betList, legs);
                const pg = props?.menuTab === "raceCard" ? "Racecard-ExpertColumn" : "ExpertColumn";
         
                try{
                    await props?.betShare?.current({ 
                        businessType: "HR",
                        betType: buttonName,
                        meetingDate: formattedDate(myContextState.selectedMeetingDate, "YYYY-MM-DD"),
                        venue: myContextState?.selectedMeetingVenueCode,
                        legs: legs,
                        target: "ewin",
                        lang: lang.langCode == "en-us" ? 'en' : 'ch',
                        betslipMode: "append",
                        b_cid: `SPLDSP_racing/simulcast-${pagename}_AddSlip`,
                        sourceFrom: `HKJCweb_JCRW_Simulcast-${pg}_${props?.expertNameEn}_${myContextState.selectedMeeting?.countryNameEn}`,
                        // onWindowFocusError: (t: any)=>{  
                        //     const contentEle = document.getElementById("expertcolumnPC")?.getBoundingClientRect();
                        //     const betWrapperEle = document.getElementsByClassName("betWrapper1")?.[0];
                        //     const rect = betWrapperEle.getBoundingClientRect(); 
                        //     console.log('AddSlipAlert', betWrapperEle, rect );
                        //     setAlertPosition((contentEle?.height || 0) - rect.height - 36); 
                        //     setShowAddSlipAlert(true);   
                        // },
                        // onError: (errorCode: any) => {
                        //     console.log("sdk error", errorCode)
                        //     setTimeout(() => {
                        //         alert(t(`expert_column_alert_error_${errorCode}`))
                        //     }, 500);
                        // } 
                    }) 
                    if(/Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || navigator.maxTouchPoints > 0){ 
                        console.log("sdk success") 
                        const contentEle = document.getElementById("expertcolumnPC")?.getBoundingClientRect();
                        const betWrapperEle = document.getElementsByClassName("betWrapper1")?.[0];
                        const rect = betWrapperEle.getBoundingClientRect(); 
                        console.log('AddSlipAlert', betWrapperEle, rect );
                        setAlertPosition((contentEle?.height || 0) - rect.height - 36); 
                        //setShowAddSlipAlert(true);  
                        addAlert()
                    }
                }catch(error: any){
                    console.log("sdk error", error)
                    setTimeout(() => {
                        alert(t(`expert_column_alert_error_${error?.errorCode ?? 500}`))
                    }, 500);
                }   
            }
        }else if(link){  
            // const target = e.currentTarget.getAttribute("target") || "_self";
            //const path = `${link}${["AddSlip", "BetType"].includes(type)  ? `&b_cid=SPLDSP_racing/simulcast-${pagename}_${type}` : ''} `;
            window.open(link) 
            // openInNewTab(link);
        }  
    }
    
    const addAlert = () => { 
        const id = Date.now() + Math.random();
        const alert = { 
            id, 
            message: `Alert ${alerts.length + 1}`
            };   
        setAlerts((prev: any[]) => [...prev, alert])
        setTimeout(() => { 
            setAlerts((prev: any[]) =>prev.filter(item => item.id !== id))
        }, 3000); 
    };

    const pmPoolStatusByStart = (oddsType: string, bet: any) => {
        const raceNo = _.orderBy(bet, ["raceNumber"], ["asc"])?.[0]?.raceNumber;
        const type = oddsType === "D-T" ? "DT" : oddsType;
        const pm = pmPoolsData?.pmPools?.filter((x: any) => x.oddsType == type && x?.leg?.races?.[0] == raceNo);

        console.log("pmPoolStatusByStart",pmPoolsData ,pm, oddsType, raceNo)
        return pm ? (pm?.[0]?.sellStatus === "START_SELL" && pm?.[0]?.status == "START_SELL") : false
    }

    console.log('betTypeList------', betTypeList)
    return   betTypeList?.length > 0 &&  
            <>
            <div className='betWrapper1' >
                {
                    betTypeList?.map((betItem: any, idx: number) => 
                    <div key={idx}>
                        <div className='betcontainer'>
                            <p className='tit'>
                                <a onClick={(e) => handleWA("BetType", '', '', betItem?.link, e)} href={betItem.link || 'javascript:;'} target={betItem.link && "_blank"} style={{ cursor: betItem.link ? "pointer" : "default" }}>
                                    {getBetSelection(betItem?.title, true)}
                                </a>
                            </p>
                            { 
                                betItem?.betList?.bet?.map((row: any, i: number) => {
                                    const hasBanker = row?.banker?.length > 0;
                                    const isThreeSelections = betTypeList?.length == 3;
                                    if (isThreeSelections) {
                                        return <div key={i} className={betItem?.betList?.betType == "D-T" ? "selections3" : "bet3"}>
                                            {
                                                
                                                betItem?.betList?.betType == "D-T" ? <>  
                                                    <p style={{
                                                        color: "#000000"
                                                    }}>
                                                        <span>{`${row?.venueCode}-${row?.raceNumber}`}</span>
                                                    </p>
                                                    <DivTopSolid/>
                                                    <p>
                                                        {hasBanker ? <span className='sty1'>{t("expert_banker")}</span> : <span className='sty1 sel'>{t("expert_sel")}</span>}
                                                    </p>
                                                    {
                                                        row?.banker?.map((item: any, num:number) => 
                                                            <p key={num}>
                                                                <span>{`${item?.horseNum}. ${item?.horseName}`}</span>
                                                            </p>)
                                                    } 
                                                    {
                                                        row?.selections?.length > 0 && <>
                                                        {hasBanker ? <p>
                                                            <span className='sty1 sel'>{t("expert_sel")}</span>
                                                        </p> : null }
                                                        {
                                                            row?.selections?.map((item: any, num:number) => 
                                                                <p key={num}>
                                                                <span>{`${item?.horseNum}. ${item?.horseName}`}</span>
                                                            </p>)
                                                        }
                                                        </>
                                                    } 
                                                </> : 
                                                <>
                                                    <div style={{
                                                        color: "#000000"
                                                    }}>{`${row?.venueCode}-${row?.raceNumber} ${row?.type}`} </div>
                                                    <DivTopSolid/>
                                                    <div>
                                                    {
                                                        row?.combination?.map((item: any, num:number) => 
                                                            <p key={num}>
                                                                <span>{`${item?.horseNum}. ${item?.horseName}`}</span>
                                                            </p>)
                                                    } 
                                                    </div>
                                                </>
                                            }
                                                
                                        </div>
                                    }
                                    return <div key={i} className={betItem?.betList?.betType == "D-T" ? "selections" : "bet"}>
                                    {
                                        
                                        betItem?.betList?.betType == "D-T" ? <>  
                                            <p>
                                                <span>{`${row?.venueCode}-${row?.raceNumber}`}</span>
                                                {hasBanker ? <span className='sty1'>{t("expert_banker")}</span> : <span className='sty1 sel'>{t("expert_sel")}</span>}
                                            </p>
                                            {
                                                row?.banker?.map((item: any, num:number) => 
                                                    <p key={num}>
                                                        <span></span>
                                                        <span>{`${item?.horseNum}. ${item?.horseName}`}</span>
                                                    </p>)
                                            } 
                                            {
                                                row?.selections?.length > 0 && <>
                                                {hasBanker ? <p>
                                                    <span></span>
                                                    <span className={`sty1 ${hasBanker? "sel" :""}`}>{t("expert_sel")}</span>
                                                </p> : null}
                                                {
                                                    row?.selections?.map((item: any, num:number) => 
                                                        <p key={num}>
                                                            <span></span>
                                                        <span>{`${item?.horseNum}. ${item?.horseName}`}</span>
                                                    </p>)
                                                }
                                                </>
                                            } 
                                        </> : 
                                        <>
                                            <div>{`${row?.venueCode}-${row?.raceNumber} ${row?.type}`} </div>
                                            <div>
                                            {
                                                row?.combination?.map((item: any, num:number) => 
                                                <p key={num}><span></span><span>{`${item?.horseNum}. ${item?.horseName}`}</span></p>)
                                            } 
                                            </div>
                                        </>
                                    }
                                        
                                </div>
                                }
                               
                                )
                            } 
                        </div>
                        <BetslipBottom $betTypeList2Length={betTypeList?.length == 2}className='btn-betslip' style={{
                            flexDirection: betTypeList?.length == 3 ? "column" : "row",
                            justifyContent: "space-between",
                            alignItems: betTypeList?.length == 3 ? "unset": "center",
                        }}>
                            <span>{t("expert_total_no_of_bets").replace("{0}", getBetSelection(betItem?.title, false))}</span>
                            {
                                TwoASwitch ? 
                                <span style={{
                                    background: !pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet) ? "#fff": "",
                                    marginTop: betTypeList?.length == 3 && (pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet)) ? 12: 0,
                                    cursor: pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet) ? "pointer" : "default"
                                    }} 
                                    > 
                                    {(pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet)) ? <a onClick={(e) => handleWA("AddSlip", getBetSelection(betItem?.title, false), betItem?.betList?.betType, betItem?.betslipLink, e, betItem?.betList?.bet)} href={betItem?.betslipLink || 'javascript:;'} target={betItem?.betslipLink && "_blank"} style={{ cursor: pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet) ? "pointer" : "default" }}>
                                        {t("add_to_betslip")}
                                    </a>: null}  
                                </span> 
                                :
                                <span style={{
                                    background: !betItem?.betslipLink || !pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet) ? "#fff": "",
                                    marginTop: betTypeList?.length == 3 && (betItem?.betslipLink && pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet)) ? 12: 0,
                                    cursor: betItem?.betslipLink && pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet) ? "pointer" : "default"
                                    }} 
                                    > 
                                    {(betItem?.betslipLink && pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet)) ? <a onClick={(e) => handleWA("AddSlip", getBetSelection(betItem?.title, false), betItem?.betList?.betType, betItem?.betslipLink, e)} href={betItem?.betslipLink || 'javascript:;'} target={betItem?.betslipLink && "_blank"} style={{ cursor: betItem?.betslipLink && pmPoolStatusByStart(betItem?.betList?.betType, betItem?.betList?.bet) ? "pointer" : "default" }}>
                                        {t("add_to_betslip")}
                                    </a>: null}  
                                </span> 
                            
                            }
                        </BetslipBottom> 
                    </div>   
                )}  
           
            </div>
            <Stack sx={{position: 'absolute', bottom: `${alertPosition}px`, left: 'calc((100% / 2) - 110px)', zIndex: '190'}}>
            {
                alerts?.map((al: any)=>(
                <Slide 
                key={al?.id}
                direction="up"  
                in={true} 
                timeout={300}  
                > 
                <Alert 
                    severity="success" 
                    iconMapping={{
                        success: <img src={`${myContextState.assetPrefix}/commonImg/successIcon.png`} ></img>,
                    }} 
                    sx={{ mb: 2, 
                        width: 'fit-content',
                        padding: '0 12px',
                        margin: '0 auto 12px',
                        color: '#000000', 
                        alignItems: 'center',
                        lineHeight: '18px',
                        fontSize: '13px',
                        fontWeight: '400',
                        backgroundColor: '#F4F4F4', 
                        borderRadius: '8px', 
                        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.15)'
                }}
                    >
                        {t("expert_column_alert")}
                </Alert>
                </Slide>
                ))
            }
            </Stack>  
            </>
}
  
export default ExpertColumnPC;
const BetslipBottom = styled.p<{ $betTypeList2Length: Boolean }>
(({ $betTypeList2Length}) => `
    @media only screen and (max-width: 1155px) {
        flex-direction: ${$betTypeList2Length ? "column !important": "inherit"};
        align-items: ${$betTypeList2Length ? "unset !important": "inherit"} ;
        & > span:last-child{
            margin-top: ${$betTypeList2Length ? '12px !important' : 'unset'} ;
        }
    }
   
`);
const InnerSpan = styled.div`
padding: 0 8px 0 12px; 
font-weight: 500;
${text_size(15)}
color: #122C68;
`;

const TriangleUp = styled.div<{ $showText: Boolean }>
(({ $showText}) => `
    width: 0;
  height: 0;
  border-left: 10px solid transparent;   
  border-right: 10px solid transparent;  
  border-bottom: 10px solid #f4f4f4;    
  position: absolute;
    bottom: -18px;
    left: 0;
    opacity: ${$showText ? 1: 0};    
`);
const TipsContainer = styled.div`     
`;

const Hiddentext = styled.div<{ $showText: Boolean }>
(({ $showText}) => `
    display: ${$showText ? 'block': 'none'}; 
    opacity: 1;         
  transition: opacity 0.2s ease;  
  position: absolute; 
    left: 0;
    padding: 5px;
    border-radius: 4px;
    top: 62px;
    width: 507px;
    height: max-content;
    background: #f4f4f4;
    z-index: 99;
    color: #000;
   ${text_size(13)}
`)

const TriangleUpDisclaimer = styled.div<{ $showDisclaimer: Boolean }>
(({ $showDisclaimer}) => `
    width: 0;
    height: 0;
    border-left: 10px solid transparent;   
    border-right: 10px solid transparent;  
    border-top: 10px solid #f4f4f4;    
    position: absolute;
    top: -12px; 
    right: 30px;
    opacity: 1; 
    display: ${$showDisclaimer ? 'block': 'none'};    
`);
const HiddenDisclaimer = styled.div<{ $showDisclaimer: Boolean }>
(({ $showDisclaimer}) => `
    display: ${$showDisclaimer ? 'block': 'none'}; 
    opacity: 1;    
    transition: opacity 0.2s ease;  
    position: absolute; 
    left: calc((100px - 507px) / 2);
    padding: 12px;
    border-radius: 4px;
    bottom: 32px;
    width: 507px;
    height: max-content;
    background: #f4f4f4;
    z-index: 161;
    color: #000;
    cursor: text;
    ${text_size(13)}
    a{
      color: #122C68;
    }
    a:hover{
      text-decoration: underline;
    }
`)

const SelectionsTitle = styled.div`
    margin: 12px 12px 0;
    padding-bottom: 8px;
    font-weight: 500;
    color: #000;
    border-bottom: 1px solid #E1E1E1;
    ${text_size(15)}
`;
const SelectionsRoot = styled.div`
    border: 1px solid #E1E1E1;
    border-radius: 4px;
    margin: 12px 0;
`;
const DisplayMoreLess = styled.span`
    ${text_size(13)}
    color: #122C68;
    font-weight: 500;
    cursor: pointer;
    float: left;
    display: flex;
    align-items: center;
`;

const RichTextCommentary = styled('div')<{ $showMore: Boolean, $show4row: Boolean, $ifshowMore: Boolean,  $showCaleNoRow: Number }>
(({ $showMore, $show4row, $showCaleNoRow, $ifshowMore}) => `
    display: ${$showMore ? "unset" : "-webkit-box"};
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${$ifshowMore? ($show4row? 4: $showCaleNoRow) : "unset"};
    overflow: hidden;
    text-overflow: ellipsis; 
    color: #000000;
    ${text_size(13)}

    a{
        color: #122C68;
    }
    a:hover {
        text-decoration: underline;
    }
`);
const ExpertColumnHeader = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: 70px;
    position: relative;
`;
const ExpertColumnHeaderImg = styled.img`
    width: 44px;
    height: 44px;
`;
const BottomContentWrapper = styled.div`
    padding: 16px 12px 20px 12px;
`;
const DivTopSolid = styled.div`
    border-top: 1px solid #B3C8D9;
    clear: both;
    margin: 4px 0 8px 0;
`;

const BetWrapper = styled.div`
    display: flex;
    gap: 10px; 
    > div {
        flex: 48%;
    }
`;

const BetItemRow = styled.div`
    display: flex;
    gap: 12px;
    color: var(--extraPalette-text-primary);
    ${text_size(13)}
    font-weight: 500;
    flex-direction: column;
    justify-content: space-between;

    p{
        line-height: 17px;
    }
`;

const BetItemTable = styled.div`
    width: 100%;
    > div + div {
        margin-top: 8px;
    }
    > div :first-of-type {
        margin-top: 4px;
    }
`;

const BetRaceRow = styled.div`
    width: 100%; 
    color: #333333;
    line-height: 17px;
    ${text_size(13)}
    font-weight: 500;
    align-items: start;

    > div {
        display: flex;
        flex-wrap: nowrap;
        gap: 15px;
    } 
    .betRaceRowBold {
        font-weight: 700;
        margin-top: 4px;
    }
    .betRaceRowFirst {
        margin-top: 8px;
    }
    > div :first-of-type {
        margin-top: 0;
    }
    .betRaceColFirst {
        white-space: nowrap;
        min-width: 30px;
    }
    @media only screen and (min-width: 1680px) {
        line-height: 20px;
        .betRaceColFirst {min-width: 35px;}
    }
    
`;
const HorseListRow = styled.div`
    display: flex;
    white-space: nowrap;
    gap: 8px;
    flex-basis: 48%;
    min-height: 28px;
    padding: 0 12px 0px;
    color: var(--extraPalette-text-primary);
    ${text_size(13)}
    font-weight: 500;
    align-items: center;

    p{
        line-height: 17px;
    }
`;
